import { useQuery } from '@tanstack/react-query';

import {
    getJobAid,
    getJobAids,
} from '@src/requests/jobAids';

const useJobAidQuery = (id) => {
    return useQuery({
        queryKey: ['job-aid', id],
        queryFn: ({ queryKey }) => getJobAid(queryKey[1]),
    });
};

const useJobAidsQuery = (search) => {
    return useQuery({
        queryKey: ['job-aids', search],
        queryFn: ({ queryKey }) => getJobAids(queryKey[1]),
    });
};

export {
    useJobAidQuery,
    useJobAidsQuery,
};
